import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.26 20.392a4.8 4.8 0 0 1-1.202.368l-6.57 1.15c-2.19.39-3.48-.51-3.86-2.7l-1.54-8.75q-.585-3.285 2.7-3.87l1.798-.316a.3.3 0 0 1 .347.348L5.757 13.28c-.53 3.03.9 5.07 3.92 5.6 0 0 5.22.917 5.488.969.332.06.385.414.094.543m6.652-13.286-1.544 8.754c-.372 2.108-1.588 3.009-3.633 2.729-.078-.011-.148-.011-.229-.025l-6.565-1.158q-3.283-.579-2.704-3.862L8.58 5.928l.201-1.138q.579-3.284 3.862-2.704l6.566 1.158q3.283.58 2.703 3.862m-6.359 6.79a.75.75 0 0 0-.608-.87l-4.104-.723a.75.75 0 1 0-.26 1.477l4.104.724a.748.748 0 0 0 .868-.608m3.043-2.861a.75.75 0 0 0-.608-.87l-6.565-1.157a.75.75 0 0 0-.26 1.477l6.565 1.158q.066.011.131.01a.75.75 0 0 0 .737-.618m.7-3.262a.75.75 0 0 0-.608-.87l-6.565-1.157a.751.751 0 0 0-.26 1.477l6.565 1.158a.748.748 0 0 0 .868-.608"
    }, null, -1)
  ])))
}
export default { render: render }